import * as React from "react"
import { cn } from "@/lib/utils"

/** Typographic, not a large grey icon (rule 6). */
function EmptyState({ title, description, action, className, ...props }) {
  return (
    <div className={cn("border-t border-line py-16 text-center", className)} {...props}>
      <p className="font-display text-subhead text-ink">{title}</p>
      {description && (
        <p className="mx-auto mt-2 max-w-sm text-small text-ink-muted">{description}</p>
      )}
      {action && <div className="mt-6 flex justify-center">{action}</div>}
    </div>
  )
}

export { EmptyState }
